<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 哮天系统
                </el-breadcrumb-item>
				<el-breadcrumb-item>分析规则</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
                <el-input v-model="query.name" placeholder="请输入规则名称" class="handle-input mr10"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px'}"
				stripe
            >
				<el-table-column prop="name" label="规则名称" width="300"></el-table-column>
				<el-table-column prop="remark" label="备注"></el-table-column>
                <el-table-column prop="createTime" label="创建时间" width="180"></el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.$index, scope.row)"
							v-if="controll['edit']"
                        >编辑</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="handleDelete(scope.$index, scope.row)"
							v-if="controll['delete']"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
			<div class="record-a-d">
				<el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
                    @click="handleAdd"
					v-if="controll['add']"
                >添加记录</el-button>
			</div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false :title="title" :visible.sync="editVisible" width="70%">
            <el-form ref="form" :model="form" label-width="80px" :rules="rules">
				<el-tabs v-model="ruleActiveName" tab-position="left">
					<el-tab-pane label="基本信息" name="baseTab">
						<el-form-item label="规则名称" prop="name">
							<el-input type=input v-model="form.name"></el-input>
						</el-form-item>
						<el-form-item label="规则备注" prop="remark">
							<el-input type=textarea :rows=16 v-model="form.remark"></el-input>
						</el-form-item>
					</el-tab-pane>
					<el-tab-pane label="注册资本评分规则" name="registeredCapitalRuleTab">
						<el-form-item prop="registeredCapitalRule" label-width="2px">
							<el-input type=textarea :rows=20 v-model="form.registeredCapitalRule"></el-input>
						</el-form-item>
					</el-tab-pane>
					<el-tab-pane label="注册时间评分规则" name="establishDateRuleTab" >
						<el-form-item prop="establishDateRule" label-width="2px">
							<el-input type=textarea :rows=20 v-model="form.establishDateRule"></el-input>
						</el-form-item>
					</el-tab-pane>
					<el-tab-pane label="参保人数评分规则" name="socialSecurityNumRuleTab" >
						<el-form-item prop="socialSecurityNumRule" label-width="2px">
							<el-input type=textarea :rows=20 v-model="form.socialSecurityNumRule"></el-input>
						</el-form-item>
					</el-tab-pane>
					<el-tab-pane label="注册地址评分规则" name="addressRuleTab" >
						<el-form-item prop="addressRule" label-width="2px">
							<el-input type=textarea :rows=20 v-model="form.addressRule"></el-input>
						</el-form-item>
					</el-tab-pane>
					<el-tab-pane label="目标终端产品规则" name="equipmentRuleTab" >
						<el-form-item prop="equipmentRule" label-width="2px">
							<el-input type=textarea :rows=20 v-model="form.equipmentRule"></el-input>
						</el-form-item>
					</el-tab-pane>
					<el-tab-pane label="目标经销品牌规则" name="componentRuleTab" >
						<el-form-item prop="componentRule" label-width="2px">
							<el-input type=textarea :rows=20 v-model="form.componentRule"></el-input>
						</el-form-item>
					</el-tab-pane>
					<el-tab-pane label="经营范围规则" name="validBusinessScopeRuleTab" >
						<el-form-item prop="businessScopeRule" label-width="2px">
							<el-input type=textarea :rows=20 v-model="form.businessScopeRule"></el-input>
						</el-form-item>
					</el-tab-pane>
					<el-tab-pane label="网站抓取规则" name="websiteRuleTab" >
						<el-form-item prop="websiteRule" label-width="2px">
							<el-input type=textarea :rows=20 v-model="form.websiteRule"></el-input>
						</el-form-item>
					</el-tab-pane>
					<el-tab-pane label="公司名保留规则" name="companyRuleTab" >
						<el-form-item prop="companyNameRule" label-width="2px">
							<el-input type=textarea :rows=20 v-model="form.companyNameRule"></el-input>
						</el-form-item>
					</el-tab-pane>
				</el-tabs>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { fetchPotentialResourcesRuleData, savePotentialResourcesRule, deletePotentialResourcesRule, getPotentialResourcesRule} from '../../../api/index';
export default {
    name: 'potential-resources-rules',
    data() {
        return {
            query: {
                code: '',
                name: '',
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
            editVisible: false,
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1,
			enumKV:[],
			title:"",
			rules: {
                name: [{ required: true, message:'请输入规则名称', trigger: 'blur' }],
                registeredCapitalRule: [{ required: true, message: '请输入注册资本评分规则', trigger: 'blur' }],
				establishDateRule: [{ required: true, message: '请输入注册时间评分规则', trigger: 'blur' }],
				socialSecurityNumRule: [{ required: true, message: '请输入社保人数评分规则', trigger: 'blur' }],
				addressRule: [{ required: true, message: '请输入地址评分规则', trigger: 'blur' }],
				equipmentRule: [{ required: true, message: '请输入目标终端产品规则', trigger: 'blur' }],
				componentRule: [{ required: true, message: '请输入目标经销品牌规则', trigger: 'blur' }],
				businessScopeRule: [{ required: true, message: '请输入经营范围规则', trigger: 'blur' }],
				websiteRule: [{ required: true, message: '请输入网页抓取规则', trigger: 'blur' }],
				companyNameRule: [{ required: true, message: '请输入公司名保留规则', trigger: 'blur' }]
            },
			ruleActiveName:"baseTab",
			controll:{}
        };
    },
    created() {
		this.controll = getControll("potential-resources-rules");
        this.getData();
    },
    methods: {
        // 获取分页数据
        getData() {
            fetchPotentialResourcesRuleData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deletePotentialResourcesRule([row.id]).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
		//添加操作
		handleAdd() {
			this.form = {};
			this.title = "添加新纪录";
			this.editVisible = true;
		},
        // 编辑操作
        handleEdit(index, row) {
            this.idx = index;
            //this.form = row;
			this.title = "编辑";
			getPotentialResourcesRule(row.id).then(res => {
				if (res.code == 0) {
					this.form = res.data;
					this.editVisible = true;
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
        },
        // 保存编辑
        saveEdit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					savePotentialResourcesRule(this.form).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.editVisible = false;
							//this.$message.success(`修改第 ${this.idx + 1} 行成功`);
							if (typeof(this.form.id) == "undefined") {
								this.getData();
							} else {
								this.$set(this.tableData, this.idx, this.form);
							}
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
